import moment from "moment";
import { Dispatch } from "redux";

import { CondominiumDTO } from "models/dto/CondominiumDTO";
import { PeriodDTO } from "models/dto/PeriodDTO";
import { api } from "services/api";

export const condominiumActionsTypes = {
  GET_CONDOMINIUMS: "GET_CONDOMINIUMS",
  GET_CONDOMINIUMS_SUCCESS: "GET_CONDOMINIUMS_SUCCESS",
  GET_CONDOMINIUMS_FAILURE: "GET_CONDOMINIUMS_FAILURE",

  GET_PERIODS: "GET_PERIODS",
  GET_PERIODS_SUCCESS: "GET_PERIODS_SUCCESS",
  GET_PERIODS_FAILURE: "GET_PERIODS_FAILURE",

  CHANGE_CONDOMINIUM: "CHANGE_CONDOMINIUM",
};

export const SESSION_STORAGE_REFERENCE = "@LelloPortalDP:reference";
export const SESSION_STORAGE_REFERENCE_NAME = "@LelloPortalDP:referenceName";

export const getCondominiums = () => async (dispatch: Dispatch) => {
  dispatch({ type: condominiumActionsTypes.GET_CONDOMINIUMS });
  try {
    const { data } = await api.get<CondominiumDTO[]>("/condominios/dp");
    if (data) {
      dispatch({
        type: condominiumActionsTypes.GET_CONDOMINIUMS_SUCCESS,
        payload: data,
      });
    }
  } catch (error) {
    dispatch({ type: condominiumActionsTypes.GET_CONDOMINIUMS_FAILURE });
  }
};

export const changeCondominium = (condominium: CondominiumDTO) => (
  dispatch: Dispatch,
) => {
  sessionStorage.setItem(
    SESSION_STORAGE_REFERENCE,
    String(condominium?.referencia),
  );
  sessionStorage.setItem(
    SESSION_STORAGE_REFERENCE_NAME,
    String(condominium?.nome),
  );
  dispatch({
    type: condominiumActionsTypes.CHANGE_CONDOMINIUM,
    payload: condominium,
  });
};

export const getPeriods = (reference: number, limit = 12) => async (
  dispatch: Dispatch,
) => {
  dispatch({ type: condominiumActionsTypes.GET_PERIODS });
  try {
    const { data } = await api.get<PeriodDTO[]>(
      `/gdp/pontos/apuracao/${reference}`,
      {
        params: {
          periodoDe: moment()
            .subtract(limit, "months")
            .startOf("month")
            .format("YYYY-MM-DD"),
          periodoAte: moment()
            .add(1, "month")
            .startOf("month")
            .format("YYYY-MM-DD"),
        },
      },
    );

    let periods: PeriodDTO[] = data;
    // REMOVE O PERÍODO AINDA NÃO INICIADO
    if (data.length > 0) {
      if (
        moment().isSameOrBefore(
          moment(
            data.sort((a, b) => (a.codigoInterno < b.codigoInterno ? 1 : -1))[0]
              .inicioMesApuracao,
            "DD/MM/YYYY",
          ),
        )
      ) {
        periods = data.slice(1, data.length - 1);
      }
    }

    dispatch({
      type: condominiumActionsTypes.GET_PERIODS_SUCCESS,
      payload: periods.sort((a, b) =>
        a.codigoInterno < b.codigoInterno ? 1 : -1,
      ),
    });
  } catch (error) {
    console.log(error);
    dispatch({ type: condominiumActionsTypes.GET_PERIODS_FAILURE });
  }
};
